// Shop All Click
document.querySelector('.shop_all')?.addEventListener('click', function () {

    // Remove active class from all categories
    // document.querySelectorAll('.category-icon-item').forEach(el => {
    //     el.classList.remove('active');
    // });

    // Clear all Wizzy filters
    const clearBtn = document.querySelector('.wizzy-filters-clear-all');

    if (clearBtn) {
        clearBtn.click();
    }

    // Scroll to products section
    setTimeout(() => {
        const productSection = document.querySelector('.wizzy-search-results-container'); // Update selector if needed

        if (productSection) {
            productSection.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }, 300);
});


// Category Click
document.querySelectorAll('.category-icon-item').forEach(item => {
    item.addEventListener('click', function () {

        // Remove active class from all categories
        document.querySelectorAll('.category-icon-item').forEach(el => {
            el.classList.remove('active');
        });

        // Add active class to clicked category
        this.classList.add('active');

        const category = this.dataset.category.toLowerCase();

        const activeFilter = document.querySelector(
            '.wizzy-facet-list-item input[type="checkbox"]:checked'
        );

        if (
            activeFilter &&
            activeFilter.closest('.wizzy-facet-list-item')?.dataset.term
                ?.toLowerCase()
                .includes(category)
        ) {
            document.querySelector('.category-icons-wrapper')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            return;
        }

        if (category === 'all') {
            const clearBtn = document.querySelector('.wizzy-filters-clear-all');

            if (clearBtn) {
                clearBtn.click();
            }

            setTimeout(() => {
                document.querySelector('.category-icons-wrapper')?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 300);

            return;
        }

        // Remove currently selected filters
        document.querySelectorAll(
            '.wizzy-facet-list-item input[type="checkbox"]:checked'
        ).forEach(checkbox => checkbox.click());

        // Apply selected category filter
        setTimeout(() => {
            document.querySelectorAll('.wizzy-facet-list-item').forEach(filter => {
                const title = (filter.dataset.term || '').toLowerCase();
                const words = title.split(' ');

                if (words.includes(category)) {
                    filter.querySelector('input[type="checkbox"]')?.click();
                }
            });

            // Scroll back to category icons
            // document.querySelector('.category-icons-wrapper')?.scrollIntoView({
            //     behavior: 'smooth',
            //     block: 'start'
            // });

        }, 100);
    });
});